export enum SaveStatusEnum {
  Save = 'Save',
  Open = 'Open',
  Ocr = 'Ocr',
  AudioSave = 'AudioSave',
  ExamCreationFilePicker = 'ExamCreationFilePicker',
  ExamModeFilePicker = 'ExamModeFilePicker',
  CompletedExamModeFileSave = 'CompletedExamModeFileSave'
}
